import React, { FC, ReactNode } from 'react';

import styles from './VaultStatsTile.module.scss';

interface Props {
  title: string;
  inactiveDesc: string;
  isActive?: boolean;
  activeDesc?: string;
  bgParticles?: string;
  value?: string;
  valuePrefix?: string;
  valueSuffix?: string;
  buttonElement?: ReactNode;
}

const VaultStatsTile: FC<Props> = ({
  isActive,
  bgParticles,
  title,
  value,
  valuePrefix,
  valueSuffix,
  activeDesc,
  inactiveDesc,
  buttonElement,
}) => (
  <div className={styles.tile}>
    <img className={styles.bgImg} src={bgParticles} alt="" />
    <p className={styles.title}>{title}</p>

    {isActive ? (
      <div className={styles.value}>
        {valuePrefix && (
          <p className={styles.valuePrefix}>
            {valuePrefix}
            &nbsp;
          </p>
        )}
        <p className={styles.valueText}>{value}</p>
        {valueSuffix && (
          <p className={styles.valueSuffix}>
            &nbsp;
            {valueSuffix}
          </p>
        )}
      </div>
    ) : (
      <p className={styles.connectWallet}>Connect your wallet</p>
    )}

    <p className={isActive ? styles.activeDesc : styles.inactiveDesc}>
      {isActive ? activeDesc : inactiveDesc}
    </p>

    {isActive && buttonElement && <div className={styles.buttonElement}>{buttonElement}</div>}
  </div>
);

export default VaultStatsTile;
